<template>
  <section class="bg">

    <Header page="respondent" :uid="uid" />

    <center>
      <div class="filters" v-if="is_data_fetched && (answers.length !== 0 || selected_favorites)">
        <a-button @click="toggleFavorites">
          {{ selected_favorites ? 'Showing Favorites' : 'Show Favorites' }} <a-icon type="star" :theme="star_theme" twoToneColor="#FFBF1D"/>
        </a-button>
      </div>
    </center>

    <div v-if="!is_data_fetched" class="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
      </a-spin>
    </div>

    <div v-else class="card-container" >
      <masonry :cols="is_mobile ? 1 : 3" :gutter="is_mobile ? 0 : 30">
        <AnswerCard v-for="answer in answers" :key="answer.id" :answer="answer" :is_respondent_page="true" />
      </masonry>
    </div>

    <center>
      <p v-if="is_data_fetched && answers.length === 0 && selected_favorites">No answers favorited yet</p>
    </center>

    <!-- Comment Drawer for the selected answer -->
    <a-drawer
      title="Comments"
      placement="right"
      :closable="true"
      width="400"
      @close="resetComments"
      :visible="comments_answer_id !== null"
    >
      <a-list
        v-if="comments && comments.length"
        :dataSource="comments"
        :header="`${comments.length} ${comments.length > 1 ? 'replies' : 'reply'}`"
        itemLayout="horizontal"
      >
      <a-list-item slot="renderItem" slot-scope="comment, index">
        <a-comment
          :author="comment.author"
          :content="comment.text"
          :datetime="getTimeFromNow(comment.time_created)"
        >
        </a-comment>
      </a-list-item>
      </a-list>
      <a-comment v-if="comments!==null" :author="user_name">
        <!-- <a-avatar
          slot="avatar"
          src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
          alt="Han Solo"
        /> -->
        <div slot="content">
          <a-form-item>
            <a-textarea :rows="3" @change="handleCommentInput" :value="new_comment" placeholder="Write your comment"></a-textarea>
          </a-form-item>
          <a-form-item>
            <a-button htmlType="submit" @click="addComment" type="primary">
              Add Comment
            </a-button>
          </a-form-item>
        </div>
      </a-comment>
    </a-drawer>

  </section>
</template>

<script>

import _ from 'lodash';
import moment from 'moment';
import Header from '@/components/Header.vue'
import AnswerCard from '@/components/answers/AnswerCard.vue'
import { isMobile, isMobileOnly } from 'mobile-device-detect';

export default {
  name: 'respondent',
  components: {
    Header,
    AnswerCard
  },
  data() {
    return {
      new_comment: "",
      selected_favorites: false,
      is_mobile: isMobileOnly
    }
  },
  computed: {
    uid() {
      return this.$route.params.uid;
    },
    answers() {
      let surveys = this.$store.state.surveys;
      if (!surveys) { return [] };
      let survey_index = this.$route.params.survey_index;
      let all_answers = surveys[survey_index].answers;
      if (!all_answers) { return [] };
      let respondents_answers = _.filter(all_answers, ['uid', this.uid]);
      respondents_answers = _.sortBy(respondents_answers, ['question_index']);
      if (this.selected_favorites) {
        respondents_answers = _.filter(respondents_answers, ['is_favorited', true]);
      };
      return respondents_answers;
    },
    is_data_fetched() {
      let survey_index = this.$route.params.survey_index;
      let survey = this.$store.state.surveys[survey_index];
      return this.$store.state.fetched_data[`${survey.id}-${this.uid}`];
    },
    comments() {
      let comment_answer_id = this.$store.state.comments_answer_id;
      if (!comment_answer_id) { return [] };
      let survey_index = this.$route.params.survey_index;
      let survey = this.$store.state.surveys[survey_index];
      if (!survey.answers) { return [] };
      let answer = _.find(survey.answers, ['id', comment_answer_id]);
      return answer.comments || [];
    },
    comments_answer_id() {
      return this.$store.state.comments_answer_id;
    },
    user_name() {
      return this.$store.state.user.name || "";
    },
    star_theme() {
      return this.selected_favorites === true ? 'twoTone' : 'outlined';
    }
  },
  methods: {

    handleCommentInput: function(e) {
      this.new_comment = e.target.value;;
    },
    addComment: function() {
      let survey_index = this.$route.params.survey_index;
      this.$store.dispatch('addComment', [survey_index, this.new_comment]);
      this.new_comment = "";
    },
    resetComments: function() {
      this.$store.commit('setCommentsAnswerID', null);
    },
    getTimeFromNow(unix) {
      return moment.unix(unix).fromNow()
    },
    toggleFavorites() {
      this.selected_favorites = !this.selected_favorites;
    }
  },

  mounted() {

    let survey_index = this.$route.params.survey_index;
    let uid = this.$route.params.uid;

    // User has refreshed the page
    if (!this.$store.state.surveys) {

      var that = this;

      // Give the app 5 seconds to re-auth the user, otherwise take them back to surveys
      setTimeout(function() {
        if (!that.$store.state.surveys) {
          that.$router.replace('/surveys'); // User hasn't authed yet, and therefore survey id hasn't been set - ideally I wait and showing loading instead of redirecting..
        } else {
          that.$store.dispatch('setAnswersForRespondent', { survey_index, uid });
        }
      }, 5000);

    } else {
      this.$store.dispatch('setAnswersForRespondent', { survey_index, uid });
    };

  },

  created() {
    analytics.page('Respondent');
  }

};
</script>

<style lang="scss" scoped>

section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

.filters{
  margin-top: 180px;
}

.card-container{
  width: 970px;
  margin: 0 auto;
  margin-top: 30px;
}

.loading{
  height: 40px;
  width: 40px;
  margin: 0 auto;
  margin-top: 180px;
  display: block;
}

.ant-btn{
  font-family:'Montserrat';
  color: #0D303F;
  font-size: 14px;
  font-weight: 600;
  &:hover{
    border-color: #1BD285;
  }
  &:active{
    border-color: #1BD285;
  }
  &:focus{
    border-color: #1BD285;
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {


.card-container{
  width: 100%;
  padding: 20px;
  margin-top: 0px;
  & > div{
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
}

.filters{
  margin-top: 160px;
}

}

/* Ipad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .card-container{
    width: 100%;
    padding: 20px;
    margin-top: 0px;
    & > div{
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  .filters{
    margin-top: 160px;
  }
}

</style>
